import React from 'react';
import { StyledCanvasContainer } from './Canvas.styled';

/**
 * At the moment, Canvas does not need CanvasBlockDataProps or CanvasExternalDataProps.
 * Omitted because, in Typescript, empty interfaces accept any non-nullable value.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `Canvas` container is the main **content** root of every campaign page
 * and can only have 1-n `Layout` blocks as children.
 */
export const Canvas = ({
  children,
  ...rest
}) => /*#__PURE__*/_jsx(StyledCanvasContainer, {
  ...rest,
  children: children
});